import { Box, Card, Typography } from "@mui/material";
import { styled } from "@mui/material";
import { List, ListItem } from "@mui/material";
import useApi from "hooks/useApi";
import { useEffect, useRef } from "react";
import { IMessage } from "types/auth";

const SelfCard = styled(Card)(({ theme }) => ({
    maxWidth: '80%',
    boxShadow: 'none',
    background: theme.palette.grey[200],
    padding: '5px 10px',
    borderRadius: '15px 15px 3px 15px'
}));

const ChatCard = styled(Card)(({ theme }) => ({
    maxWidth: '80%',
    boxShadow: 'none',
    background: theme.palette.primary.main,
    color: "#ffff",
    padding: '5px 10px',
    borderRadius: '15px 15px 15px 3px'
}));

const ChatList = ({ chatList }: any) => {
    // const { messages } = useSession();
    const { user } = useApi();
    const lastItemRef = useRef<HTMLLIElement | null>(null);
    useEffect(() => {
        if (lastItemRef.current) {
            lastItemRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
    }, [chatList]);

    const SelfCardContent = ({ isFirstInStreak, chat }: { chat: IMessage, isFirstInStreak: boolean }) => {
        return (
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'end', ...isFirstInStreak ? { marginTop: '10px' } : {} }}>
                <SelfCard>
                    <Typography variant="caption">{chat.message}</Typography>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'end' }}>
                        <Typography color={'gray'} fontSize={'8px'} variant="body2">{new Date(chat.createdAt).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</Typography>
                    </Box>
                </SelfCard>
            </Box>
        )
    }

    const ChatCardContent = ({ isFirstInStreak, chat }: { chat: IMessage, isFirstInStreak: boolean }) => {
        return (
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', ...isFirstInStreak ? { marginTop: '10px' } : {} }}>

                <ChatCard>
                    {isFirstInStreak && (
                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                            <Typography fontSize={'10px'} variant="body2" fontWeight={'bold'} sx={{ textTransform: "capitalize" }}>{chat.fromName}</Typography>
                        </Box>
                    )}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                        }}
                    >
                        {/* Left aligned message */}
                        <Typography variant="caption">{chat.message}</Typography>

                        {/* Right aligned time */}
                        <Typography fontSize="8px" variant="body2">
                            {new Date(chat.createdAt).toLocaleString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                            })}
                        </Typography>
                    </Box>

                </ChatCard>
            </Box>
        )
    }

    return (
        <List sx={{
            width: '100%',
            bgcolor: 'background.paper',
            flex: 1
        }} dense={true}>
            <Typography sx={{ fontWeight: "600", fontSize: "14px" }}>Chat History:</Typography>
            {!chatList?.length ? (
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        textAlign: 'center',
                        width: '100%',
                        p: 2
                    }}
                >
                    <Typography
                        color="text.secondary"
                        sx={{
                            fontSize: '0.875rem',
                            fontStyle: 'italic'
                        }}
                    >
                        No messages
                    </Typography>
                </Box>
            ) : (
                chatList.map((chat: any, index: number) => {
                    const isFirstInStreak = index === 0 || chatList[index - 1].uid !== chat.uid;
                    const isSelf = chat?.uid == user.uid;
                    return (
                        <ListItem
                            ref={index === chatList?.length - 1 ? lastItemRef : null}
                            sx={{
                                justifyContent: isSelf ? 'flex-end' : 'flex-start',
                                display: 'flex'
                            }}
                        >
                            {isSelf
                                ? <SelfCardContent {...{ isFirstInStreak, chat }} />
                                : <ChatCardContent {...{ isFirstInStreak, chat }} />}
                        </ListItem>
                    )
                }))
            }
        </List>
    )
}

export default ChatList;